import $ from 'jquery';

var chartColors = ["#003b2a", "#1c4f40", "#4e766a", "#819d94", "#a1d9bf", "#e0c9a9", "#000000"];
var lineChartColors = ["#1b9e77", "#d95f02", "#7570b3", "#e7298a", "#66a61e", "#e6ab02"];
var unit = "€";
var timeFormat = "MM/YY";

function setInitialData(data) {
  var dataSets = [];
  var index = 0;
  Object.keys(data.revenue.data).forEach(function(company) {
    dataSets.push({
      label: company,
      data: data.revenue.data[company],
      borderWidth: 4,
      fill: false,
      lineTension: 0,
      borderColor: lineChartColors[index],
      backgroundColor: lineChartColors[index],
      pointBackgroundColor: lineChartColors[index],
      pointBorderColor: "#FFF",
      pointHoverBorderColor: lineChartColors[index],
    });
    if (index < lineChartColors.length - 1) {
      index++;
    } else {
      index = 0;
    }
  });

  return dataSets;
}

function legendClickCallback(event) {
  event = event || window.event;

  var target = event.target || event.srcElement;
  while (target.nodeName !== "LI") {
    target = target.parentElement;
  }
  var parent = target.parentElement;
  var chartId = parseInt(parent.classList[0].split("-")[0], 10);
  var chart = Chart.instances[chartId];
  var index = Array.prototype.slice.call(parent.children).indexOf(target);

  chart.legend.options.onClick.call(chart, event, chart.legend.legendItems[index]);
  if (chart.isDatasetVisible(index)) {
    target.classList.remove("inactive");
  } else {
    target.classList.add("inactive");
  }
}

$(document).on("turbo:load", function() {
  moment.locale("fi");
  var chartSelect = $("[data-chart-select]");
  if (chartSelect) {
    chartSelect.change(function() {
      var value = $(this).val();
      var dataSets = [];
      window.myChart.data.datasets.forEach(function(set) {
        if (window.myChartData[value].data[set.label]) {
          set.data = window.myChartData[value].data[set.label];
        } else {
          set.data = null;
        }
      });

      unit = window.myChartData[value].unit;

      window.myChart.update();
      updateLegend(window.myChart);
    });
  }
});

function makeLegend(chart) {
  var text = [];
  text.push('<ul class="' + chart.id + '-legend">');
  for (var i = 0; i < chart.data.datasets.length; i++) {
    if (chart.data.datasets[i].data && chart.data.datasets[i].data.length > 0) {
      text.push(
        '<li><span style="background-color:' + chart.data.datasets[i].backgroundColor + '"></span>'
      );
      if (chart.data.datasets[i].label) {
        text.push(chart.data.datasets[i].label);
      }
      text.push("</li>");
    }
  }
  text.push("</ul>");
  return text.join("");
}

function updateLegend(chart) {
  var compareLegend = document.querySelector("[data-compare-legend]");
  // generate HTML legend
  compareLegend.innerHTML = makeLegend(chart);

  // bind onClick event to all LI-tags of the legend
  var legendItems = compareLegend.getElementsByTagName("li");
  for (var i = 0; i < legendItems.length; i += 1) {
    legendItems[i].addEventListener("click", legendClickCallback, false);
  }
}

function filterLegendLabel(item, chart) {
  var showLabel = true;
  chart.datasets.forEach(function(set) {
    if (set.label === item.text && (set.data && set.data.length === 0)) {
      showLabel = false;
    }
  });
  return showLabel;
}

function compareChartConfig(data) {
  return {
    type: "line",
    data: { datasets: setInitialData(data) },
    options: {
      responsive: true,
      animation: { duration: 500, easing: "easeInOutQuad" },
      hover: { intersect: true, axis: "y", mode: "point" },
      layout: { padding: { left: 0, right: 0, top: 0, bottom: 0 } },
      tooltips: {
        backgroundColor: "#FFF",
        cornerRadius: 0,
        titleFontFamily:
          "'Hanken Grotesk', brandon-grotesque, 'Helvetica Neue', Helvetica, Arial, sans-serif",
        bodyFontFamily:
          "'Hanken Grotesk', brandon-grotesque, 'Helvetica Neue', Helvetica, Arial, sans-serif",
        titleFontSize: 14,
        bodyFontSize: 14,
        titleMarginBottom: 8,
        xPadding: 10,
        yPadding: 14,
        displayColors: false,
        borderWidth: 1,
        borderColor: "#d9e0e0",
        titleFontColor: "black",
        bodyFontColor: "black",
        caretSize: 8,
        caretPadding: 8,
        callbacks: {
          label: function(tooltipItem, data) {
            var label = data.datasets[tooltipItem.datasetIndex].label || "";

            if (label) {
              label += ": ";
            }
            label +=
              tooltipItem.yLabel.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") + " " + unit;
            return label;
          },
        },
      },
      legend: {
        display: false,
        position: "bottom",
        fullWidth: false,
        labels: {
          boxWidth: 20,
          padding: 50,
          fontSize: 16,
          usePointStyle: true,
          filter: function(item, chart) {
            return filterLegendLabel(item, chart);
          },
        },
      },
      elements: {
        point: { radius: 10, borderWidth: 4, hitRadius: 20, hoverRadius: 10 },
      },
      scales: {
        xAxes: [
          {
            type: "time",
            time: {
              parser: timeFormat,
              unit: "month",
              minUnit: "month",
              displayFormats: { month: "M/YY" },
              tooltipFormat: "MMMM YYYY",
            },
            gridLines: {
              display: true,
              drawBorder: false,
              color: "#d9e0e0",
              tickMarkLength: 10,
              drawOnChartArea: false,
            },
            ticks: {
              fontFamily: "'Hanken Grotesk', brandon-grotesque, 'Helvetica Neue', Helvetica, Arial, sans-serif",
              fontColor: "#4f5656",
              fontSize: 13,
              maxRotation: 0,
              padding: 8,
            },
          },
        ],
        yAxes: [
          {
            gridLines: {
              display: true,
              color: "#d9e0e0",
              drawBorder: false,
              tickMarkLength: 15,
            },
            ticks: {
              padding: 8,
              fontFamily: "'Hanken Grotesk', brandon-grotesque, 'Helvetica Neue', Helvetica, Arial, sans-serif",
              fontColor: "#4f5656",
              fontSize: 13,
              callback: function(value, index, values) {
                // Maximum rotation for tick labels when rotating to condense labels. // Padding between the tick label and the axis.
                return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") + " " + unit;
              },
            },
          },
        ],
        minor: { fontSize: 6 },
      },
    },
  };
}

$(document).on("turbo:load", function() {
  var compareChart = $("[data-compare-line-chart]");
  var compareLegend = document.querySelector("[data-compare-legend]");
  var lineCharts = $("[data-company-line-chart]");
  if (compareChart.length) {
    window.myChart = new Chart(compareChart, compareChartConfig(compareChart.data("chartData")));
    window.myChartData = compareChart.data("chartData");

    updateLegend(window.myChart);
  }
  if (lineCharts.length) {
    lineCharts.each(function(index, lineChart) {
      var chart = new Chart(lineChart, {
        type: "line",
        data: {
          labels: ["Tammikuu", "Maaliskuu", "Toukokuu", "Heinäkuu", "Syyskuu", "Marraskuu"],
          datasets: [
            {
              label: "Liikevaihto",
              data: [900000, 924000, 933000, 941000, 931000, 961000],
              backgroundColor: chartColors[index],
              borderColor: chartColors[index],
              pointBackgroundColor: chartColors[index],
              borderWidth: 2,
              fill: false,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          layout: {
            padding: {
              left: 0,
              right: 0,
              top: 0,
              bottom: 0,
            },
          },
          tooltips: {
            backgroundColor: "#222222",
            cornerRadius: 0,
            bodyFontFamily:
              "'Hanken Grotesk', brandon-grotesque, 'Helvetica Neue', Helvetica, Arial, sans-serif",
            titleFontSize: 14,
            bodyFontSize: 14,
            xPadding: 12,
            yPadding: 12,
            displayColors: false,
          },
          legend: { display: false },
          elements: {
            point: {
              radius: 3,
              hitRadius: 10,
              hoverRadius: 7,
            },
          },
          scales: {
            xAxes: [
              {
                gridLines: {
                  color: "transparent",
                  zeroLineWidth: 0,
                },
              },
            ],
            yAxes: [
              {
                gridLines: {},
              },
            ],
            minor: {
              fontSize: 6,
            },
          },
        },
      });
    });
  }
});

Chart.plugins.register({
  afterDatasetsDraw: function(chart) {
    var chart_type = chart.config.type;
    if (chart.tooltip._active && chart.tooltip._active.length && chart_type === "line") {
      var activePoint = chart.tooltip._active[0],
        ctx = chart.chart.ctx,
        x_axis = chart.scales["x-axis-0"],
        y_axis = chart.scales["y-axis-0"],
        x = activePoint.tooltipPosition().x,
        topY = y_axis.top,
        bottomY = y_axis.bottom;

      // draw line
      ctx.save();
      ctx.beginPath();
      ctx.moveTo(x, topY + 1);
      ctx.lineTo(x, bottomY - 1);
      ctx.setLineDash([3, 6]);
      ctx.lineWidth = 1;
      ctx.strokeStyle = "#9ca3a3";
      ctx.stroke();
      ctx.restore();
    }
  },
});
